package com.evoapps.evoshift.ui.user

import androidx.compose.material.icons.filled.Timeline
import evoshift.composeapp.generated.resources.timeline_mine
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.MenuRowCard
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.widgets.rememberStableText
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.di.diViewModel
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.filled.DeleteForever
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoDialog
import evoshift.composeapp.generated.resources.delete_account_confirm
import evoshift.composeapp.generated.resources.delete_account_word
import evoshift.composeapp.generated.resources.delete_account_type
import evoshift.composeapp.generated.resources.delete_account_other_apps
import evoshift.composeapp.generated.resources.delete_account_text
import evoshift.composeapp.generated.resources.delete_account_title
import evoshift.composeapp.generated.resources.delete_account
import androidx.compose.material3.TextButton
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.cost_rules_add_first
import evoshift.composeapp.generated.resources.cost_rules_empty
import evoshift.composeapp.generated.resources.cost_rules_manage
import evoshift.composeapp.generated.resources.cost_rules_title
import evoshift.composeapp.generated.resources.details
import evoshift.composeapp.generated.resources.profile_business_name
import evoshift.composeapp.generated.resources.profile_cost_summary
import evoshift.composeapp.generated.resources.profile_daily_total
import evoshift.composeapp.generated.resources.profile_monthly_total
import evoshift.composeapp.generated.resources.profile_yearly_total
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.ListMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.TwoPane
import com.evoapps.evoshift.ui.adaptive.cardClickable
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.AttachMoney
import androidx.compose.material.icons.filled.Business
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Event
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Save
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.CostFrequency
import com.evoapps.evoshift.viewmodels.ProfileEvent
import com.evoapps.evoshift.viewmodels.ProfileViewModel
import com.evoapps.evoshift.widgets.LoadingOverlay
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.calendar_sub_title
import evoshift.composeapp.generated.resources.documents_mine
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.edit
import evoshift.composeapp.generated.resources.error
import evoshift.composeapp.generated.resources.profile_display_name
import evoshift.composeapp.generated.resources.profile_my_profile
import evoshift.composeapp.generated.resources.profile_no_user_data
import evoshift.composeapp.generated.resources.profile_save_changes
import evoshift.composeapp.generated.resources.profile_sign_out
import evoshift.composeapp.generated.resources.notif_settings_title
import evoshift.composeapp.generated.resources.help_centre_desc
import evoshift.composeapp.generated.resources.help_centre_title
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.util.appLanguage
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.platform.testTag
import androidx.compose.material.icons.automirrored.outlined.HelpOutline
import androidx.compose.material.icons.automirrored.filled.OpenInNew
import evoshift.composeapp.generated.resources.unknown
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ProfileScreen(
    viewModel: ProfileViewModel,
    onNavigateToAuth: () -> Unit,
    onNavigateToRecurringCosts: () -> Unit,
    /** SH-131: the owner's shared costs of the business. */
    onNavigateToSharedCosts: () -> Unit = {},
    /** SH-267: the owner's workplace groups. */
    onNavigateToWorkplaceGroups: () -> Unit = {},
    /** SH-270: the owner's roles and access. */
    onNavigateToRoles: () -> Unit = {},
    onNavigateBack: () -> Unit,
    /** Which notifications are pushed (SH-73). */
    onNavigateToNotificationSettings: () -> Unit = {},
    /** SH-122: my documents at the current workplace; null without one. */
    onNavigateToMyDocuments: (() -> Unit)? = null,
    /** SH-212: my timeline at the current workplace (read-only); null without one. */
    onNavigateToMyTimeline: (() -> Unit)? = null,
    /** SH-146: whether "What's new" shows the owners' and managers' notes (else the employees'). */
    whatsNewForManager: Boolean = false,
    /** The owner's plan and subscription (SH-38); shown to owners only. */
    planEntry: @Composable () -> Unit = {}
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()

    LaunchedEffect(state.isSignedOut) {
        if (state.isSignedOut) {
            onNavigateToAuth()
        }
    }

    // Lokalne stany edycji (inicjowane danymi z usera)
    var editName by remember(state.currentUser) {
        mutableStateOf(
            state.currentUser?.displayName ?: ""
        )
    }
    var editBusinessName by remember(state.ownerProfile) {
        mutableStateOf(
            state.ownerProfile?.businessName ?: ""
        )
    }

    val snackbarHostState = remember { SnackbarHostState() }
    val unknownText = stringResource(Res.string.unknown)

    // Obsługa komunikatów (Sukces / Błąd)
    val errorText = state.error?.asString()
    val successText = state.successMessage?.asString()
    LaunchedEffect(errorText, successText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(ProfileEvent.MessageShown)
        }
        successText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(ProfileEvent.MessageShown)
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.profile_my_profile),
                onBack = onNavigateBack,
                backDescription = stringResource(Res.string.cancel),
                actions = listOf(
                    if (state.isEditing) {
                        TopBarAction(stringResource(Res.string.cancel), Icons.Default.Close, { viewModel.onEvent(ProfileEvent.ToggleEditMode) }, collapsible = false)
                    } else {
                        TopBarAction(stringResource(Res.string.edit), Icons.Default.Edit, { viewModel.onEvent(ProfileEvent.ToggleEditMode) }, collapsible = false)
                    }
                )
            )
        }
    ) { padding ->
        val isExpanded = LocalWindowWidthClass.current.isExpanded
        val maxWidth = if (isExpanded) ListMaxWidth else ContentMaxWidth
        Box(modifier = Modifier.padding(padding).fillMaxSize()) {
            if (state.currentUser == null && !state.isLoading) {
                // User niezaładowany
                Text(
                    stringResource(Res.string.profile_no_user_data),
                    modifier = Modifier.align(Alignment.Center)
                )
            } else {
                val isOwner = state.isAnyWorkplaceOwner && state.ownerProfile != null
                // The same pieces in both layouts, so phones keep exactly their column.
                val avatar: @Composable () -> Unit = {
                    // SH-94: the photo (uploaded and cropped in the app, or the Google one), or initials.
                    ProfilePhotoEditor(viewModel = diViewModel(), snackbarHostState = snackbarHostState)
                }
                val editForm: @Composable () -> Unit = {
                    rememberStableText(editName, { editName = it }).let { stable ->
                        OutlinedTextField(
                            value = stable.value,
                            onValueChange = stable.onValueChange,
                            label = { Text(stringResource(Res.string.profile_display_name)) },
                            modifier = Modifier.fillMaxWidth()
                        )
                    }

                    if (state.isAnyWorkplaceOwner) {
                        rememberStableText(editBusinessName, { editBusinessName = it }).let { stable ->
                            OutlinedTextField(
                                value = stable.value,
                                onValueChange = stable.onValueChange,
                                label = { Text(stringResource(Res.string.profile_business_name)) },
                                modifier = Modifier.fillMaxWidth()
                            )
                        }
                    }

                    Button(
                        onClick = {
                            viewModel.onEvent(
                                ProfileEvent.UpdateProfile(
                                    newName = editName,
                                    newBusinessName = if (state.isAnyWorkplaceOwner) editBusinessName else null
                                )
                            )
                        },
                        enabled = !state.isSaving,
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        if (state.isSaving) {
                            CircularProgressIndicator(
                                modifier = Modifier.size(18.dp),
                                color = LocalContentColor.current,
                                strokeWidth = 2.dp
                            )
                        } else {
                            Icon(Icons.Default.Save, contentDescription = null)
                        }
                        Spacer(Modifier.width(8.dp))
                        Text(stringResource(Res.string.profile_save_changes))
                    }
                }
                val nameHeader: @Composable () -> Unit = {
                    // Tryb tylko do odczytu
                    Column(horizontalAlignment = Alignment.CenterHorizontally) {
                        Text(
                            text = state.currentUser?.displayName ?: unknownText,
                            style = MaterialTheme.typography.headlineMedium,
                            fontWeight = FontWeight.SemiBold
                        )
                            
                        if (state.isAnyWorkplaceOwner && state.ownerProfile != null) {
                            Spacer(Modifier.height(8.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(
                                    imageVector = Icons.Default.Business,
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp),
                                    tint = MaterialTheme.colorScheme.primary
                                )
                                Spacer(Modifier.width(4.dp))
                                Text(
                                    text = state.ownerProfile?.businessName ?: "",
                                    style = MaterialTheme.typography.titleMedium,
                                    color = MaterialTheme.colorScheme.primary
                                )
                            }
                        }
                    }
                }
                val costRules: @Composable () -> Unit = {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        Text(
                            text = stringResource(Res.string.cost_rules_title),
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.Bold
                        )
                                
                        // SH-87: a summary of costs: the revenue rules are not in it.
                        val rules = state.recurringCostRules.filter { it.kind == com.evoapps.evoshift.domain.model.LedgerKind.COST }
                        if (rules.isNotEmpty()) {
                            // Group by currency and calculate
                            // For simplicity, let's assume all rules should be summed if they share same currency
                            // and we show the first found currency for the total label
                            val firstCurrency = state.workplaceCurrencies.values.firstOrNull() ?: "PLN"
                                    
                            val monthlyTotal = rules.sumOf { rule ->
                                if (rule.frequency == CostFrequency.MONTHLY) rule.amount else 0.0
                            }
                            val dailyTotal = rules.sumOf { rule ->
                                when (rule.frequency) {
                                    CostFrequency.WEEKLY -> rule.amount / 7.0
                                    CostFrequency.MONTHLY -> rule.amount / 30.44 // Avg month
                                    CostFrequency.YEARLY -> rule.amount / 365.25
                                    else -> 0.0
                                }
                            }
                            val yearlyTotal = rules.sumOf { rule ->
                                when (rule.frequency) {
                                    CostFrequency.YEARLY -> rule.amount
                                    CostFrequency.MONTHLY -> rule.amount * 12
                                    CostFrequency.WEEKLY -> rule.amount * 52.17
                                    else -> 0.0
                                }
                            }
                                    
                            // SH-213: the team list's card surface, not pale cream on cream.
                            RegularCard(
                                modifier = Modifier.fillMaxWidth(),
                                onClick = { onNavigateToRecurringCosts() }
                            ) {
                                Column(
                                    modifier = Modifier.padding(16.dp),
                                    verticalArrangement = Arrangement.spacedBy(8.dp)
                                ) {
                                    Row(
                                        modifier = Modifier.fillMaxWidth(),
                                        horizontalArrangement = Arrangement.SpaceBetween,
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Row(verticalAlignment = Alignment.CenterVertically) {
                                            Icon(Icons.Default.AttachMoney, contentDescription = null, tint = MaterialTheme.colorScheme.primary)
                                            Spacer(modifier = Modifier.width(8.dp))
                                            Text(stringResource(Res.string.profile_cost_summary))
                                        }
                                        Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = stringResource(Res.string.details))
                                    }
                                            
                                    HorizontalDivider(modifier = Modifier.padding(vertical = 4.dp))
                                            
                                    if (monthlyTotal > 0) {
                                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                            Text(stringResource(Res.string.profile_monthly_total))
                                            Text(text = formatMoney(monthlyTotal, firstCurrency), fontWeight = FontWeight.Bold)
                                        }
                                    }
                                    if (dailyTotal > 0) {
                                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                            Text(stringResource(Res.string.profile_daily_total))
                                            Text(text = formatMoney(dailyTotal, firstCurrency), fontWeight = FontWeight.Bold)
                                        }
                                    }
                                    if (yearlyTotal > 0) {
                                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                            Text(stringResource(Res.string.profile_yearly_total))
                                            Text(text = formatMoney(yearlyTotal, firstCurrency), fontWeight = FontWeight.Bold)
                                        }
                                    }
                                }
                            }
                        } else {
                            Text(
                                text = stringResource(Res.string.cost_rules_empty),
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                                
                        androidx.compose.material3.TextButton(
                            onClick = onNavigateToRecurringCosts,
                            modifier = Modifier.align(Alignment.End)
                        ) {
                            Icon(Icons.Default.Add, contentDescription = null)
                            Spacer(modifier = Modifier.width(4.dp))
                            Text(if (rules.isEmpty()) stringResource(Res.string.cost_rules_add_first) else stringResource(Res.string.cost_rules_manage))
                        }
                    }
                }
                // SH-131: costs of the whole business, a section of its own (not a workplace's cost).
                val sharedCosts: @Composable () -> Unit = {
                    com.evoapps.evoshift.ui.user.SharedCostsProfileSection(count = state.sharedCostCount, onOpen = onNavigateToSharedCosts)
                }
                // SH-267: which of the owner's workplaces share people (two or more workplaces only).
                val workplaceGroups: @Composable () -> Unit = {
                    if (state.ownedWorkplaceCount > 1) WorkplaceGroupsProfileSection(onOpen = onNavigateToWorkplaceGroups)
                }
                // SH-270: who may see and change what (the owner's roles).
                val roles: @Composable () -> Unit = { RolesProfileSection(onOpen = onNavigateToRoles) }
                val notificationSettings: @Composable () -> Unit = {
                    MenuRowCard(Icons.Default.Notifications, stringResource(Res.string.notif_settings_title), onClick = { onNavigateToNotificationSettings() })
                }
                // SH-202: "Your shifts in your calendar" (also from My shifts → Add to calendar).
                val calendarEntry: @Composable () -> Unit = {
                    var showCalendar by remember { mutableStateOf(false) }
                    MenuRowCard(Icons.Default.Event, stringResource(Res.string.calendar_sub_title), onClick = { showCalendar = true })
                    if (showCalendar) {
                        com.evoapps.evoshift.ui.calendar.CalendarSubscriptionDialog(onDismiss = { showCalendar = false })
                    }
                }
                // SH-122: my contract, certificates and other documents at the current workplace.
                val myDocuments: @Composable () -> Unit = {
                    if (onNavigateToMyDocuments != null) {
                        MenuRowCard(Icons.Default.Description, stringResource(Res.string.documents_mine), onClick = { onNavigateToMyDocuments() })
                    }
                    // SH-212: what applies to me here and from when.
                    if (onNavigateToMyTimeline != null) {
                        MenuRowCard(Icons.Default.Timeline, stringResource(Res.string.timeline_mine), onClick = { onNavigateToMyTimeline() })
                    }
                }
                // SH-137: the app language (the device's, Polski, English, Українська).
                val language: @Composable () -> Unit = {
                    LanguageCard(viewModel = diViewModel())
                }
                // SH-196: the app's colours (base and accent), with a preview.
                val appearance: @Composable () -> Unit = {
                    AppearanceCard(viewModel = diViewModel(), onMessage = { snackbarHostState.showSnackbar(it) })
                }
                // SH-146: the notes of this version, next to the help centre.
                val whatsNew: @Composable () -> Unit = {
                    com.evoapps.evoshift.ui.whatsnew.WhatsNewCard(forManager = whatsNewForManager)
                }
                // SH-107: the PIN for the workplace's clock-in tablet.
                val kioskPin: @Composable () -> Unit = {
                    com.evoapps.evoshift.ui.kiosk.KioskPinCard(onMessage = { snackbarHostState.showSnackbar(it) })
                }
                // The help centre (SH-77): its index, in the app's language.
                val uriHandler = LocalUriHandler.current
                val helpCentre: @Composable () -> Unit = {
                    val language = appLanguage()
                    MenuRowCard(
                        Icons.AutoMirrored.Outlined.HelpOutline,
                        stringResource(Res.string.help_centre_title),
                        onClick = {
                            com.evoapps.evoshift.observability.AppTelemetry.log(com.evoapps.evoshift.observability.AnalyticsEvent.HelpOpened(HelpPage.INDEX.slug))
                            uriHandler.openUri(HelpPage.INDEX.url(language))
                        },
                        modifier = Modifier.testTag("help_centre_card"),
                        subtitle = stringResource(Res.string.help_centre_desc),
                        trailingIcon = Icons.AutoMirrored.Filled.OpenInNew
                    )
                }
                // Crash reports and usage statistics (SH-86), changeable any time.
                // SH-47: what my workplaces keep about me (my own only, read-only).
                val myStaffDetails: @Composable () -> Unit = {
                    MyStaffDetailsCard(viewModel = diViewModel())
                }
                val privacyChoices: @Composable () -> Unit = {
                    com.evoapps.evoshift.ui.legal.PrivacyChoicesCard(viewModel = diViewModel())
                    // SH-135: whether other employers see the availability (two or more employers only).
                    AvailabilitySharingCard(viewModel = diViewModel())
                }
                val signOut: @Composable () -> Unit = {
                    Button(
                        onClick = { viewModel.onEvent(ProfileEvent.SignOut) },
                        colors = ButtonDefaults.buttonColors(
                            containerColor = MaterialTheme.colorScheme.errorContainer,
                            contentColor = MaterialTheme.colorScheme.onErrorContainer
                        ),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        // Uses AutoMirrored icon (requires material-icons-extended usually, or navigation)
                        // If this errors, change to Icons.Default.Close or similar
                        Icon(Icons.AutoMirrored.Filled.ExitToApp, contentDescription = null)
                        Spacer(Modifier.width(8.dp))
                        Text(stringResource(Res.string.profile_sign_out))
                    }
                }
                // Deleting the account (GDPR, store rules): a quiet link under sign-out, confirmed
                // by typing a word, since it cannot be undone.
                var showDeleteDialog by remember { mutableStateOf(false) }
                val deleteAccount: @Composable () -> Unit = {
                    com.evoapps.evoshift.ui.legal.DataExportEntry() // GDPR: download my data (SH-27)
                    TextButton(
                        onClick = { showDeleteDialog = true },
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text(stringResource(Res.string.delete_account), color = MaterialTheme.colorScheme.error)
                    }
                    if (showDeleteDialog) {
                        DeleteAccountDialog(
                            isDeleting = state.isDeleting,
                            onConfirm = { viewModel.onEvent(ProfileEvent.DeleteAccount) },
                            onDismiss = { if (!state.isDeleting) showDeleteDialog = false }
                        )
                    }
                    // A refusal (e.g. still owning workplaces) closes the dialog so the message shows.
                    LaunchedEffect(state.error) { if (state.error != null) showDeleteDialog = false }
                    com.evoapps.evoshift.ui.legal.LegalLinks() // privacy policy and terms (SH-50)
                }

                // Wide windows: who you are on the left, what you edit or manage on the right.
                // Without anything for the right pane (a non-owner viewing) the column stays.
                if (isExpanded && (state.isEditing || isOwner)) {
                    TwoPane(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(maxWidth)
                            .padding(32.dp),
                        firstWeight = 0.4f,
                        spacing = 32.dp,
                        first = {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clip(RoundedCornerShape(20.dp))
                                    .background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f))
                                    .padding(24.dp),
                                horizontalAlignment = Alignment.CenterHorizontally,
                                verticalArrangement = Arrangement.spacedBy(24.dp)
                            ) {
                                avatar()
                                if (!state.isEditing) {
                                    nameHeader()
                                    HorizontalDivider()
                                    myStaffDetails()
                                    myDocuments()
                                    calendarEntry()
                                    notificationSettings()
                                    language()
                                    appearance()
                                    kioskPin()
                                    helpCentre()
                                    whatsNew()
                                    privacyChoices()
                                    signOut()
                                    deleteAccount()
                                }
                            }
                        },
                        second = {
                            Column(
                                modifier = Modifier.fillMaxWidth(),
                                verticalArrangement = Arrangement.spacedBy(24.dp)
                            ) {
                                if (state.isEditing) editForm() else {
                                    if (state.capabilities.shows(Gate.PLAN)) planEntry()
                                    if (state.capabilities.shows(Gate.RECURRING_COSTS)) {
                                        costRules()
                                        sharedCosts()
                                        workplaceGroups()
                                        roles()
                                    }
                                }
                            }
                        }
                    )
                } else {
                    // SH-161: a single column keeps the reading width on wide windows too.
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(ContentMaxWidth)
                            .padding(24.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(24.dp)
                    ) {
                        avatar()

                        // --- FORMULARZ ---
                        if (state.isEditing) {
                            editForm()
                        } else {
                            nameHeader()

                            HorizontalDivider()

                            // Sekcja stringResource(Res.string.cost_rules_title) dla Ownera
                            if (isOwner) {
                                if (state.capabilities.shows(Gate.PLAN)) planEntry()
                                if (state.capabilities.shows(Gate.RECURRING_COSTS)) {
                                    costRules()
                                    sharedCosts()
                                    workplaceGroups()
                                    roles()
                                }
                                HorizontalDivider()
                            }

                            myStaffDetails()
                            myDocuments()
                            calendarEntry()
                            notificationSettings()
                            language()
                            appearance()
                            kioskPin()
                            helpCentre()
                            whatsNew()
                            privacyChoices()

                            Spacer(modifier = Modifier.weight(1f)) // Push to bottom

                            signOut()
                            deleteAccount()
                        }
                    }
                }
            }

            LoadingOverlay(isLoading = state.isLoading && state.currentUser == null)
        }
    }
}

@Composable
private fun DeleteAccountDialog(isDeleting: Boolean, onConfirm: () -> Unit, onDismiss: () -> Unit) {
    val word = stringResource(Res.string.delete_account_word)
    var typed by remember { mutableStateOf("") }
    val confirmed = typed.trim().equals(word, ignoreCase = true)
    EvoDialog(
        title = stringResource(Res.string.delete_account_title),
        icon = Icons.Default.DeleteForever,
        onDismiss = onDismiss,
        width = DialogWidth.Compact,
        destructive = true,
        dismissible = !isDeleting,
        confirm = DialogAction(
            stringResource(Res.string.delete_account_confirm),
            { if (confirmed) onConfirm() },
            enabled = confirmed,
            loading = isDeleting
        )
    ) {
        Text(stringResource(Res.string.delete_account_text), color = Color.White.copy(alpha = 0.85f))
        // SH-243: the EVo sign-in may stay for EVoLabels.
        Text(stringResource(Res.string.delete_account_other_apps), color = Color.White.copy(alpha = 0.85f))
        EvoTextField(
            value = typed,
            onValueChange = { typed = it },
            label = stringResource(Res.string.delete_account_type, word),
            capitalization = KeyboardCapitalization.Characters,
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { if (confirmed && !isDeleting) onConfirm() }),
            enabled = !isDeleting
        )
    }
}
